<template>
  <div class="download-detail-page">
    <div class="content-wrapper">
      <div class="video-info" v-if="videoInfo">
        <div class="cover">
          <img :src="videoInfo.image" alt="" />
        </div>
        <div class="detail">
          <h1>{{ videoInfo.title }}</h1>
          <p class="brief">{{ videoInfo.brief }}</p>
          <div class="meta">
            <span v-if="videoInfo.fileSize">大小：{{ videoInfo.fileSize }}</span>
            <span v-if="videoInfo.format">格式：{{ videoInfo.format }}</span>
          </div>
          <el-button type="danger" @click="downloadFile">下载</el-button>
        </div>
      </div>
      <div class="recommend-list" v-if="recommendList.length > 0">
        <h3>相关推荐</h3>
        <ul>
          <li v-for="item in recommendList" :key="item.id" @click="goDetail(item)">
            <img :src="item.image" alt="" />
            <span>{{ item.title }}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { getToken, getUser } from '@/utils/auth'

export default {
  name: 'DownloadDetailPage',
  data() {
    return {
      videoInfo: null,
      recommendList: []
    }
  },
  mounted() {
    this.getVideoInfo()
  },
  watch: {
    '$route.query.id'() {
      this.getVideoInfo()
    }
  },
  methods: {
    getVideoInfo() {
      const id = this.$route.query.id
      if (!id) return
      this.$axios({
        url: '/realNet/video/getVideoInfos',
        method: 'get',
        params: { id },
        headers: { token: getToken() }
      }).then(res => {
        if (res.data.code === 200) {
          const result = res.data.result
          this.videoInfo = result.videoInfo || result
          this.recommendList = result.recommendList || []
        }
      })
    },
    downloadFile() {
      if (!getUser()) {
        this.$message({ message: '请先登录', type: 'warning' })
        return
      }
      if (this.videoInfo.downloadUrl) {
        const downloadWin = window.open('/downloading.html', '_blank', 'width=500,height=200')
        setTimeout(() => {
          if (downloadWin) {
            downloadWin.postMessage({
              target: this.videoInfo.downloadUrl,
              saveName: this.videoInfo.title,
              token: getToken()
            }, '*')
          }
        }, 1000)
        this.$axios({
          url: '/realNet/download/insert',
          method: 'post',
          data: { videoId: this.$route.query.id },
          headers: { token: getToken() }
        })
      }
    },
    goDetail(item) {
      this.$router.push({ path: '/download-detail', query: { id: item.id } })
    }
  }
}
</script>

<style lang="scss" scoped>

.download-detail-page {
  padding-top: $header-height + 30px;
}

.content-wrapper {
  width: $content-width;
  margin: 0 auto;
}

.video-info {
  display: flex;
  gap: 30px;

  .cover img {
    width: 300px;
    height: 200px;
    object-fit: cover;
    border-radius: $border-radius;
  }

  .detail {
    flex: 1;

    h1 { font-size: 24px; margin-bottom: 15px; }
    .brief { font-size: 14px; color: #666; line-height: 1.8; margin-bottom: 15px; }
    .meta {
      font-size: 14px;
      color: $text-light;
      margin-bottom: 20px;
      span { margin-right: 20px; }
    }
  }
}

.recommend-list {
  margin-top: 40px;
  h3 { font-size: 18px; margin-bottom: 15px; }

  ul {
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
    list-style: none;
    padding: 0;

    li {
      width: 185px;
      cursor: pointer;
      img {
        width: 185px;
        height: 105px;
        object-fit: cover;
        border-radius: $border-radius;
      }
      span {
        display: block;
        font-size: 14px;
        margin-top: 8px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
}
</style>
